module.exports = __webpack_public_path__ + "static/media/nopicture.8720cfe6.png";